import React from 'react'
import './Intro.css'
import Github from '../../img/github.png' ;
import LinkedIn from '../../img/linkedin1.png' ;
import Instagram from '../../img/instagram.png' ;
import Twitter from '../../img/Twiiter2.png' ;
import Vector1 from '../../img/Vector1.png' ;
import Vector2 from '../../img/Vector2.png' ;
import boy from '../../img/boy.png' ;
import thumbup from '../../img/thumbup.png' ;
import Crown from '../../img/crown.png' ;
import glassesimoji from '../../img/glassesimoji.png' ;
import Akash from '../../img/Akash1.png' ;
import AkashN from '../../img/AkashNew.png' ;
import AkashN2 from '../../img/AkashNew2.png' ;
import FloatingDiv from '../FloatingDiv/FloatingDiv';
import { themeContext } from '../../Context';
import { useContext } from 'react';
import { motion } from 'framer-motion';
import {Link} from 'react-scroll'
const Intro = () => {
  const transition = {duration :2} ;
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="intro">
        <div className="i-left">
        <div className="i-name">
            <span style={{color:darkMode? 'white': ''}}>Hey! I am </span>
            <span>Akash Yadav</span>
            <span>Frontend Developer with high end level of experience in web designing and development, producting the Quality work</span>
        </div>
        <Link spy={true} to='Contacts' smooth={true} activeClass='activeClass'>
          <button className="i-button button">Hire me</button>
        </Link>
        <div className="i-icons">
          <a href='https://github.com/akash701752' target={"_blank"}><img src={Github} alt="" /> </a>
          <a href='https://www.linkedin.com/in/akash7017/' target={"_blank"} ><img src={LinkedIn} alt="" /> </a>
          <a href='https://www.instagram.com/' target={"_blank"}><img src={Instagram} alt="" /> </a>
          <a href='https://twitter.com/AakashOO' target={"_blank"}><img src={Twitter} alt="" /> </a>
        </div>
        </div>
        <div className="i-right">
          <img src={Vector1} alt="" />
          <img src={Vector2} alt="" />
          <img src={AkashN2} alt="" />
          <motion.img 
          initial={{left:'-40%'}}
          whileInView={{left:'-30%'}}
          transition={transition}

          src={glassesimoji} alt="" />
          <motion.div 
          initial={{top:'-4%' ,left:'-75%'}}
          whileInView={{left:'69%'}}
          transition={transition}
          style={{top:'-15%',left:'68%'}}
          className='floating-div'>
            <FloatingDiv image={Crown} text1='Web' text2='Developer'/>
          </motion.div>
          <motion.div 
          initial={{top:'18rem' ,left:'18rem'}}
          whileInView={{left:'-1rem'}}
          transition={transition}
          style={{top:'20rem',left:'-3.75rem'}}
          className='floating-div'>
            <FloatingDiv image={thumbup} text1='Tech' text2='Enthusiast'/>
          </motion.div>
          <div className="blur" style={{background:"rgb(238 210 255)"}}>
          </div>
          <div className="blur" style={{
            background:'#C1F5FF',
            top:'17rem',
            width:'21rem',
            height:'11rem',
            left:'-9rem'
          }}>
          </div>
        </div>
    </div>
  )
}

export default Intro